const List = () => import("@/pages/master/tickets/List")
const Form = () => import("@/pages/master/tickets/Form")
// import List from '@/pages/master/tickets/List'
// import Form from '@/pages/master/tickets/Form'
import layout from "@/layout/Master"

const data = [
  {
    path: "/master/tickets",
    name: "tickets-list",
    components: {
      content: List,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Tickets" },
        { title: "List", active: true }
      ],
      title: "Tickets List",
      module: "Tickets",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/tickets/view/:id",
    name: "tickets-view",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Tickets" },
        { title: "View", active: true }
      ],
      title: "Tickets View",
      module: "Tickets",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/tickets/edit/:id",
    name: "tickets-edit",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Tickets" },
        { title: "Edit", active: true }
      ],
      title: "Tickets Edit",
      module: "Tickets",
      showLink: false,
      requiresAuth: true
    }
  }
]
export default data
